import { cn } from "@/lib/utils";
import type { WizardStep } from "@/application/provisioning/types";

const STEPS: { key: WizardStep; label: string }[] = [
  { key: "contact", label: "Contact" },
  { key: "business", label: "Business" },
  { key: "address", label: "Address" },
  { key: "review", label: "Review" },
];

export function WizardProgress({ currentStep }: { currentStep: WizardStep }) {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep);

  return (
    <div className="flex items-center">
      {STEPS.map((step, i) => (
        <div
          key={step.key}
          className={cn("flex items-center", i < STEPS.length - 1 && "flex-1")}
        >
          <div className="flex shrink-0 items-center gap-2">
            <div
              className={cn(
                "flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold transition-colors",
                i <= currentIndex
                  ? "bg-blue-600 text-white"
                  : "bg-muted text-muted-foreground",
              )}
            >
              {i + 1}
            </div>
            <span
              className={cn(
                "text-sm font-medium transition-colors",
                i <= currentIndex ? "text-blue-600" : "text-subtle-foreground",
              )}
            >
              {step.label}
            </span>
          </div>
          {i < STEPS.length - 1 && (
            <div
              className={cn(
                "mx-4 h-px flex-1",
                i < currentIndex ? "bg-blue-600" : "bg-muted",
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
